import * as React from 'react';

import {Breakpoint} from '../../Breakpoint';
import {Modal} from '../../modal';

type TooltipProps = {
    title: string;
    text: string;
};

// tslint:disable-next-line function-name
export function Tooltip(props: TooltipProps): JSX.Element | null {
    if (Breakpoint.smaller('md')) {
        Modal.open(props.title, props.text, 't-yellow--golden-poppy');

        // tslint:disable-next-line no-null-keyword
        return null;
    }

    return (
        <div className="c-quickscan__tooltip">
            <div className="c-quickscan__tooltip__container">
                <h2 className="c-quickscan__tooltip__title">{props.title}</h2>
                <div className="c-quickscan__tooltip__text" dangerouslySetInnerHTML={{__html : props.text}}></div>
            </div>
        </div>
    );
}
